import store from "../store-root";
import api from "../../service/api";
import queryString from "querystring";

const moduleName = "materialPurchase";

store.registerModule(moduleName, {
  namespaced: true,
  state: {
    materialPurchaseList: {
      list: [],
      total: 0,
    },
  },
  actions: {
    //查询养殖品种列表;
    async getMaterialPurchaseData({ commit }, payload) {
      let result = await api.get(
        `/api/MaterialPurchase?${queryString.stringify(payload)}`
      );
      if (result.status === 200) {
        commit("setMaterialPurchaseList", result.data);
      }
      return result;
    },
    //删除列表单个数据
    async delMaterialPurchaseDetail(a, payload) {
      let result = await api.delete(`/api/MaterialPurchase/detail/` + payload);
      return result;
    },
    //删除整个单子数据
    async delMaterialPurchase(a, payload) {
      let result = await api.delete(`/api/MaterialPurchase/` + payload);
      return result;
    },
    //添加物资
    async addMaterialPurchase(a, payload) {
      let result = await api.post("/api/MaterialPurchase", payload);
      return result.data;
    },
    //编辑物资
    async editMaterialPurchase(a, payload) {
      let result = await api.get(`/api/MaterialPurchase/` + payload);
      return result.data;
    },
    //修改
    async updateMaterialPurchase(a, payload) {
      let result = await api.put(
        `/api/MaterialPurchase/${payload.id}`,
        payload.data
      );
      return result.data;
    },
    //获取物资名称
    async getProductList(a, payload) {
      let result = await api.get(
        `/api/MaterialPurchase/Dropdown?typeId=${payload}`
      );
      return result.data;
    },
  },
  mutations: {
    setMaterialPurchaseList(state, payload) {
      payload.list = payload.list.map((item) => {
        if (item.type == 1 || item.type == "") {
          item.type = "--";
        }
        return item;
      });
      state.materialPurchaseList = payload;
    },
  },
  getters: {},
});

export default moduleName;
